///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { KbTextBoxBaseComponent } from './../text-box.base.component';

@Component({
    selector: 'kb-password-text-box',
    templateUrl: './password-text-box.component.html',
})
export class KbPasswordTextBoxComponent extends KbTextBoxBaseComponent {
    @ViewChild('passwordInput')
    public passwordInput: ElementRef;
}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/shared/components/password-text-box/password-text-box.component.ts